import { useEffect, useState } from "react";
import { IconCheck, IconCopy } from "@/components/icons";
import { FieldLabel } from "@/components/admin/AdminShell";

export function LinkCopyField({
  label,
  url,
  href,
  onCopyError,
}: {
  label: string;
  url: string;
  href?: string;
  onCopyError?: (message: string) => void;
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
    } catch {
      onCopyError?.("Не удалось скопировать ссылку");
    }
  };

  return (
    <div>
      <FieldLabel size="compact">{label}</FieldLabel>
      <div className="mt-1 flex items-center gap-1 rounded-lg border border-slate-200 bg-white p-1">
        <a
          href={href ?? url}
          target="_blank"
          rel="noopener noreferrer"
          className="min-w-0 flex-1 truncate px-2 py-1.5 font-onest text-xs text-brand-700 hover:underline"
          title={url}
        >
          {url.replace(/^https?:\/\//, "")}
        </a>
        <button
          type="button"
          title={copied ? "Скопировано" : "Копировать ссылку"}
          aria-label={copied ? "Скопировано" : "Копировать ссылку"}
          onClick={() => void handleCopy()}
          className={[
            "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border transition-colors",
            copied
              ? "border-emerald-200 bg-emerald-50 text-emerald-700"
              : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50",
          ].join(" ")}
        >
          {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
        </button>
      </div>
    </div>
  );
}
